(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("alpheios-data-models"), require("uuid/v4"), require("papaparse"));
	else if(typeof define === 'function' && define.amd)
		define(["alpheios-data-models", "uuid/v4", "papaparse"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("alpheios-data-models"), require("uuid/v4"), require("papaparse")) : factory(root["alpheios-data-models"], root["uuid/v4"], root["papaparse"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(self, function(__WEBPACK_EXTERNAL_MODULE_alpheios_data_models__, __WEBPACK_EXTERNAL_MODULE_uuid_v4__, __WEBPACK_EXTERNAL_MODULE_papaparse__) {
return 